import { createSlice } from "@reduxjs/toolkit";

const sosSettingSlice = createSlice({
  name: "sosSettingSlice",
  initialState: {
    appActivityData: null,
    callSmsDetailData: null,
  },
  reducers: {
    setCallSmsData: (state, action) => {
      state.callSmsData = action?.payload;
    },
    setCallSmsDetailData: (state, action) => {
      state.callSmsDetailData = action?.payload;
    },
    clearSosSettings: (state, action) => {
      state.appActivityData = null;
      state.callSmsDetailData = null;
    }
  },
});

// this is for dispatch
export const { setCallSmsData, setCallSmsDetailData, clearSosSettings } = sosSettingSlice.actions;

// this is for configureStore
export default sosSettingSlice.reducer;
